import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../firebase/config';
import { findGapIssues } from '../utils';

/**
 * Load all gap issues for a user
 */
export const loadGapIssuesForUser = async (userEmail, comicsIGot) => {
  const db = firestore;

  // Get all heroes
  const heroesRef = collection(db, "users/" + userEmail + "/heroes/");
  const heroSnapshot = await getDocs(heroesRef);
  
  const allComics = [];
  const promises = [];

  heroSnapshot.forEach((heroDoc) => {
    const heroName = heroDoc.data().name;
    const heroData = heroDoc.data().data;

    // Get all series for this hero
    const seriesRef = collection(db, "users/" + userEmail + "/heroes/" + heroName + "/series");
    const seriesPromise = getDocs(seriesRef).then((seriesSnapshot) => {
      const seriesPromises = [];

      seriesSnapshot.forEach((seriesDoc) => {
        const seriesTitle = seriesDoc.data().title;
        const seriesData = seriesDoc.data().data;

        // Get all comics for this series
        const comicsRef = collection(db, "users/" + userEmail + "/heroes/" + heroName + "/series/" + seriesTitle + "/comics");
        const comicsPromise = getDocs(comicsRef).then((comicsSnapshot) => {
          comicsSnapshot.forEach((comicDoc) => {
            const comicData = comicDoc.data().data;
            // Collect all comics with hero and series metadata for gap analysis
            allComics.push({
              ...comicData,
              heroName: heroName,
              heroData: heroData,
              seriesData: seriesData,
              seriesTitle: seriesTitle
            });
          });
        });
        seriesPromises.push(comicsPromise);
      });

      return Promise.all(seriesPromises);
    });
    promises.push(seriesPromise);
  });

  await Promise.all(promises);
  
  // Use findGapIssues to identify only comics that are gaps
  return findGapIssues(allComics, comicsIGot);
};
